import { mapActions, mapGetters, mapState } from 'vuex';
import loaderMixin from '@/mixins/loader';
import sessionHistorySushi from '@/components/session-history-sushi/session-history-sushi.vue';
import productHistorySushi from '@/components/product-history-sushi/product-history-sushi.vue';
import watchlistSushi from '@/components/watchlist-sushi/watchlist-sushi.vue';
import sushiMarketLinksToggle from '../sushi-market-links-toggle/sushi-market-links-toggle.vue';

const SECTIONS = {
  WATCHLIST: 'watchlist',
  SESSION_HISTORY: 'session-history',
  PRODUCT_HISTORY: 'product-history',
};

export default {
  mixins: [
    loaderMixin,
  ],
  data() {
    return {
      opened: [],
      SECTIONS,
    }
  },
  components: {
    sessionHistorySushi,
    productHistorySushi,
    watchlistSushi,
    sushiMarketLinksToggle
  },
  computed: {
    ...mapState('market', ['market', 'isMarketHistoryPinned', 'isWatchlistPinned', 'isSessionHistoryPinned', 'pinnedOpened']),
    ...mapGetters('market', ['historyData']),
    sections () {
      const results = []
      if (this.isWatchlistPinned) {
        results.push({ name: SECTIONS.WATCHLIST, title: 'Watchlist' });
      }

      if (this.isSessionHistoryPinned) {
        results.push({ name: SECTIONS.SESSION_HISTORY, title: 'Session List' });
      }

      // if (this.isMarketHistoryPinned) {
      //   results.push({ name: SECTIONS.PRODUCT_HISTORY, title: 'Product History' });
      // }

      return results
    },
  },
  methods: {
    ...mapActions('market', ['toggleOpenPinSection']),
    sectionClassModifiers(section) {
      return {
        'sushi-market-links-widget__section': true,
        'sushi-market-links-widget__section--opened': this.isSectionOpen(section),
      };
    },
    isSectionOpen(section) {
      return this.pinnedOpened.includes(section.name);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/components/sushi-market-links-widget/sushi-market-links-widget.js